module.exports = __webpack_public_path__ + "static/media/q4.6ee1ac8c.png";